// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * BEST Tools shared theme.
 * Keep these values in sync with the BEST Tools login page (best-tools repo)
 * and any other BEST Tools app, so all screens share one look and feel.
 */
:root {
  --bt-navy-text: #282E69;
  --bt-button-navy: #121D5D;
  --bt-action-blue: #4197F8;
  --bt-green-accent: #6DC07F;
  --bt-gold-accent: #F6DC8E;
  --bt-mint: #EAF6EE;
  --bt-neutral-panel: #E9ECEF;

  --bt-text-muted: #5f6368;
  --bt-border: #e3e5e8;
  --bt-page-bg: #f7f8fa;
  --bt-font: Arial, Helvetica, sans-serif;
}

/* Buttons */
.bt-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 28px;
  border-radius: 6px;
  border: 1px solid transparent;
  font-family: var(--bt-font);
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.bt-btn-primary {
  background-color: var(--bt-button-navy);
  border-color: var(--bt-button-navy);
  color: #fff;
}

.bt-btn-primary:hover {
  background-color: var(--bt-navy-text);
}

.bt-btn-secondary {
  background-color: #fff;
  border-color: var(--bt-button-navy);
  color: var(--bt-button-navy);
  padding: 8px 20px;
}

.bt-btn-secondary:hover {
  background-color: var(--bt-neutral-panel);
}

.bt-btn-action {
  background-color: var(--bt-action-blue);
  border-color: var(--bt-action-blue);
  color: #fff;
}

/* Centered auth page (Access Denied, Login) */
.bt-auth-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  box-sizing: border-box;
  background-color: var(--bt-page-bg);
  font-family: var(--bt-font);
  /* Static screen: no text cursor or selection, only the button is interactive */
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  caret-color: transparent;
}

.bt-auth-page img {
  -webkit-user-drag: none;
}

.bt-auth-card {
  width: 100%;
  max-width: 420px;
  box-sizing: border-box;
  padding: 40px 32px;
  background-color: #fff;
  border: 1px solid var(--bt-border);
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(18, 29, 93, 0.08);
  text-align: center;
}

.bt-auth-logo {
  width: 140px;
  height: auto;
  margin-bottom: 16px;
}

.bt-auth-title {
  margin: 0 0 16px;
  color: var(--bt-navy-text);
  font-size: 24px;
  font-weight: bold;
}

.bt-auth-message {
  margin: 0 0 24px;
  color: var(--bt-text-muted);
  font-size: 15px;
  line-height: 1.5;
}

.bt-auth-footer {
  margin-top: 32px;
  color: #9aa0a6;
  font-size: 13px;
}

/* App header (logo | app name ... actions) */
.bt-app-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 0 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid var(--bt-border);
  font-family: var(--bt-font);
}

.bt-app-header-brand {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.bt-app-header-logo {
  height: 32px;
  width: auto;
}

.bt-app-header-divider {
  width: 1px;
  height: 28px;
  background-color: var(--bt-border);
}

.bt-app-header .bt-app-header-title {
  margin: 0;
  color: var(--bt-navy-text);
  font-size: 20px;
  font-weight: bold;
  white-space: nowrap;
}

/* Full-page loading spinner (matches the BEST Tools login callback) */
.bt-loading-page {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}

.bt-spinner {
  width: 48px;
  height: 48px;
  box-sizing: border-box;
  border: 4px solid var(--bt-neutral-panel);
  border-top-color: var(--bt-action-blue);
  border-radius: 50%;
  animation: bt-spin 0.8s linear infinite;
}

@keyframes bt-spin {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/theme.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;;EAE3B,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;EACnC,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,WAAW;AACb;;AAEA,8CAA8C;AAC9C;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,mCAAmC;EACnC,2BAA2B;EAC3B,+EAA+E;EAC/E,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,kCAAkC;EAClC,mBAAmB;EACnB,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,sEAAsE;AACtE;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yCAAyC;EACzC,uCAAuC;EACvC,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":["/*\n * BEST Tools shared theme.\n * Keep these values in sync with the BEST Tools login page (best-tools repo)\n * and any other BEST Tools app, so all screens share one look and feel.\n */\n:root {\n  --bt-navy-text: #282E69;\n  --bt-button-navy: #121D5D;\n  --bt-action-blue: #4197F8;\n  --bt-green-accent: #6DC07F;\n  --bt-gold-accent: #F6DC8E;\n  --bt-mint: #EAF6EE;\n  --bt-neutral-panel: #E9ECEF;\n\n  --bt-text-muted: #5f6368;\n  --bt-border: #e3e5e8;\n  --bt-page-bg: #f7f8fa;\n  --bt-font: Arial, Helvetica, sans-serif;\n}\n\n/* Buttons */\n.bt-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px 28px;\n  border-radius: 6px;\n  border: 1px solid transparent;\n  font-family: var(--bt-font);\n  font-size: 15px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.bt-btn-primary {\n  background-color: var(--bt-button-navy);\n  border-color: var(--bt-button-navy);\n  color: #fff;\n}\n\n.bt-btn-primary:hover {\n  background-color: var(--bt-navy-text);\n}\n\n.bt-btn-secondary {\n  background-color: #fff;\n  border-color: var(--bt-button-navy);\n  color: var(--bt-button-navy);\n  padding: 8px 20px;\n}\n\n.bt-btn-secondary:hover {\n  background-color: var(--bt-neutral-panel);\n}\n\n.bt-btn-action {\n  background-color: var(--bt-action-blue);\n  border-color: var(--bt-action-blue);\n  color: #fff;\n}\n\n/* Centered auth page (Access Denied, Login) */\n.bt-auth-page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 16px;\n  box-sizing: border-box;\n  background-color: var(--bt-page-bg);\n  font-family: var(--bt-font);\n  /* Static screen: no text cursor or selection, only the button is interactive */\n  cursor: default;\n  user-select: none;\n  caret-color: transparent;\n}\n\n.bt-auth-page img {\n  -webkit-user-drag: none;\n}\n\n.bt-auth-card {\n  width: 100%;\n  max-width: 420px;\n  box-sizing: border-box;\n  padding: 40px 32px;\n  background-color: #fff;\n  border: 1px solid var(--bt-border);\n  border-radius: 14px;\n  box-shadow: 0 8px 24px rgba(18, 29, 93, 0.08);\n  text-align: center;\n}\n\n.bt-auth-logo {\n  width: 140px;\n  height: auto;\n  margin-bottom: 16px;\n}\n\n.bt-auth-title {\n  margin: 0 0 16px;\n  color: var(--bt-navy-text);\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.bt-auth-message {\n  margin: 0 0 24px;\n  color: var(--bt-text-muted);\n  font-size: 15px;\n  line-height: 1.5;\n}\n\n.bt-auth-footer {\n  margin-top: 32px;\n  color: #9aa0a6;\n  font-size: 13px;\n}\n\n/* App header (logo | app name ... actions) */\n.bt-app-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 8px 0 16px;\n  margin-bottom: 16px;\n  border-bottom: 1px solid var(--bt-border);\n  font-family: var(--bt-font);\n}\n\n.bt-app-header-brand {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 0;\n}\n\n.bt-app-header-logo {\n  height: 32px;\n  width: auto;\n}\n\n.bt-app-header-divider {\n  width: 1px;\n  height: 28px;\n  background-color: var(--bt-border);\n}\n\n.bt-app-header .bt-app-header-title {\n  margin: 0;\n  color: var(--bt-navy-text);\n  font-size: 20px;\n  font-weight: bold;\n  white-space: nowrap;\n}\n\n/* Full-page loading spinner (matches the BEST Tools login callback) */\n.bt-loading-page {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #fff;\n}\n\n.bt-spinner {\n  width: 48px;\n  height: 48px;\n  box-sizing: border-box;\n  border: 4px solid var(--bt-neutral-panel);\n  border-top-color: var(--bt-action-blue);\n  border-radius: 50%;\n  animation: bt-spin 0.8s linear infinite;\n}\n\n@keyframes bt-spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
